import { ReviewSet } from '@models/ui/review-set.model';
import { Component, Input, ViewChild } from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReviewSetService } from '@services/review-set.service';
import { BulkDocAddPayload } from '@models/review/bulk-doc-add-payload.model';
import { SelectionService } from '@models/review/selection-service';
import { SearchParameter } from '@models/review/search-parameter.model';
import { AddDocsToReviewSetDialogComponent } from '../add-docs-to-review-set-dialog/add-docs-to-review-set-dialog.component';
import { EmailFamilyCountManager } from '@managers/email-family-count.manager';
import { ModifyReviewSetDialogComponent } from '../../discovery/review-sets/create-review-set-dialog/modify-review-set-dialog.component';
import { ReviewSetSdk } from '@sdks/review-set.sdk';
import { NotificationManager } from "@managers/notification.manager";
import { BaseComponent } from "../../base.component";

@Component({
    selector: 'lex-review-set',
    templateUrl: './review-set.component.html',
    styleUrls: ['./review-set.component.scss'],
    standalone: false
})
export class ReviewSetComponent extends BaseComponent {
	@Input() searchParameter: SearchParameter;
	@Input() expandEmailFamilySelected: boolean;
	public available: ReviewSet[] = new Array<ReviewSet>();

	@ViewChild('selectReviewSet') selectReviewSet: MatSelect;

	constructor(
		private reviewSetService: ReviewSetService,
		public selectionService: SelectionService,
		private emailFamilyCountManager: EmailFamilyCountManager,
		private dialog: MatDialog,
		private matDialog: MatDialog,
		private reviewSetSdk: ReviewSetSdk,
		private notificationManager: NotificationManager
	) {
		super();
		this.refreshSets();
	}

	public onReviewSetSelected(change: MatSelectChange) {
		this.addDocs(change.value);
	}

	private addDocs(reviewSet: ReviewSet) {
		this.selectionService.operationAlert = null;
		const payload = this.createBulkPayload();
		this.emailFamilyCountManager.GetExpandedEmailFamilyDocCount(payload).subscribe(expandedDocCount => {
			this.openConfirmDialog(expandedDocCount, reviewSet);
		});
	}

	public openAddReviewSetDialog(): void {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.width = '500px';
		this.matDialog.open(ModifyReviewSetDialogComponent, dialogConfig).afterClosed()
			.subscribe((result) => {
				this.refreshSets();
				if (!result?.reviewSet) return;

				if (this.selectionService.SelectedCount > 0) {
					this.addDocs(result?.reviewSet);
				}

				this.notificationManager.displaySnackBarMessage({
					message: `Review Set successfully created!`,
					type: 'info'
				});
			});
	}

	private openConfirmDialog(expandedDocCount: number, reviewSet: ReviewSet) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.minWidth = '350px';
		dialogConfig.minHeight = '250px';
		dialogConfig.data = {
			reviewSetName: reviewSet?.name,
			selectedDocCount: this.selectionService.SelectedCount,
			expandedDocCount: expandedDocCount,
			expandDocs: this.expandEmailFamilySelected
		};
		dialogConfig.panelClass = "add-docs-to-job-panel";

		this.dialog.open(AddDocsToReviewSetDialogComponent, dialogConfig).afterClosed().subscribe((expand: boolean = null) => {
			if (expand !== null) { // ok clicked
				const payload = this.createBulkPayload();
				payload.expandEmailFamily = expand;
				this.reviewSetService.addDocsToReviewSet(reviewSet.id, payload)
					.subscribe(() => {
						this.notificationManager.displaySnackBarMessage({ message: `Adding documents to ${reviewSet.name}...`, ttl: 5000 });
						if (this.selectReviewSet)
							this.selectReviewSet.writeValue(null);
					});
			} else if (this.selectReviewSet) {
				this.selectReviewSet.writeValue(null);
			}
		});
	}

	private createBulkPayload(): BulkDocAddPayload {
		const payload: BulkDocAddPayload = new BulkDocAddPayload();
		payload.docIds = this.selectionService.selection.selected.map(s => s.docId);
		payload.selectAll = this.selectionService.selectAllFlag;
		payload.filterId = this.selectionService.getSavedFilterId();
		payload.searchParameter = this.searchParameter;

		return payload;
	}

	private refreshSets(): void {
		this.reviewSetSdk.get()
			.subscribe({
				next: (data) => {
					this.available = data.filter(set => set.status === 'pre-review');
				}
			});
	}
}
